<template>
  <component :is="dinamycComponent()" />
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { defineAsyncComponent } from "vue";	
import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth.store";
import { useConfigStore } from "@/store/config.store";

const AboutGamificationTemplate = defineAsyncComponent(() => import("./components/AboutGamificationTemplate.vue"));
const GamificationActivatedTemplate = defineAsyncComponent(() => import("./components/GamificationActivatedTemplate.vue"));
const StudentGamificationTemplate = defineAsyncComponent(() => import("./components/StudentGamificationTemplate.vue"));

const authStore = useAuthStore()
const configStore = useConfigStore()

const router = useRouter();
const getIsGamificationActive = computed(() => configStore.getIsGamificationActive);
const getIsAdmin = computed(() => authStore.isAdmin());


function dinamycComponent() {
	if (getIsAdmin.value) {
		return getIsGamificationActive.value ? GamificationActivatedTemplate : AboutGamificationTemplate;
	} else if (getIsGamificationActive.value) {
		return StudentGamificationTemplate;
	}

	return router.push({ name: "Home" });
}
</script>
